
class LanguageHelper
{
    static #StorageKey = "locale";
    static Default = "fa";

    static set(lang) {
        localStorage.setItem(this.#StorageKey, lang);
    }

    static get() {
        return localStorage.getItem(this.#StorageKey) ?? this.Default;
    }
}

export default LanguageHelper;